import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'yyyyMMddFormat',
})
export class YyyyMMddFormatPipe implements PipeTransform {
  private static readonly YYYYMMDD = /^\d{8}$/;
  private static readonly YMD_DASHED = /^\d{4}-\d{2}-\d{2}$/;
  private static readonly YMD_HMS_DASHED =
    /^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}:\d{2}$/;
  private static readonly YYYYMMDDHHMMSS = /^\d{14}$/;

  constructor(private readonly datePipe: DatePipe) {}

  transform(
    value: string | Date | null | undefined,
    mode: 'date' | 'datetime' = 'date',
  ): string {
    if (value == null || value === '') return '';

    const date = this.parseToDate(value);
    if (!date) return '';

    const format = mode === 'datetime' ? 'yyyy/MM/dd HH:mm:ss' : 'yyyy/MM/dd';
    return (
      this.datePipe.transform(date, format) ??
      (typeof value === 'string' ? value : '')
    );
  }

  private parseToDate(input: string | Date): Date | null {
    if (input instanceof Date) return isNaN(input.getTime()) ? null : input;

    const trimmed = input.trim();

    if (YyyyMMddFormatPipe.YYYYMMDD.test(trimmed)) {
      return this.makeDate(
        Number(trimmed.slice(0, 4)),
        Number(trimmed.slice(4, 6)),
        Number(trimmed.slice(6, 8)),
      );
    }

    if (YyyyMMddFormatPipe.YMD_DASHED.test(trimmed)) {
      const ymd = trimmed.replace(/-/g, '');
      return this.makeDate(
        Number(ymd.slice(0, 4)),
        Number(ymd.slice(4, 6)),
        Number(ymd.slice(6, 8)),
      );
    }

    if (YyyyMMddFormatPipe.YYYYMMDDHHMMSS.test(trimmed)) {
      const y = Number(trimmed.slice(0, 4));
      const M = Number(trimmed.slice(4, 6));
      const d = Number(trimmed.slice(6, 8));
      const hh = Number(trimmed.slice(8, 10));
      const mm = Number(trimmed.slice(10, 12));
      const ss = Number(trimmed.slice(12, 14));
      const dt = new Date(y, M - 1, d, hh, mm, ss);
      return isNaN(dt.getTime()) ? null : dt;
    }

    if (YyyyMMddFormatPipe.YMD_HMS_DASHED.test(trimmed)) {
      const normalized = trimmed.replace(' ', 'T');
      const iso = new Date(normalized);
      return isNaN(iso.getTime()) ? null : iso;
    }

    const tryIso = new Date(trimmed);
    if (!isNaN(tryIso.getTime())) return tryIso;

    return null;
  }

  private makeDate(year: number, month: number, day: number): Date | null {
    const d = new Date(year, month - 1, day);
    return d.getFullYear() === year &&
      d.getMonth() === month - 1 &&
      d.getDate() === day
      ? d
      : null;
  }
}
